module.exports = __webpack_public_path__ + "img/uganda-reco.d29c4a56.svg";